{
  "blocks": [
    {
      "id": "proc-hysteroscopy",
      "kind": "procedure",
      "tags": ["clinic-visit", "her", "testing", "pre-cycle", "practical"],
      "title": "Hysteroscopy",
      "subtitle": "Direct camera visualization of the uterine cavity for diagnosis and treatment",
      "body": {
        "procedureName": "Hysteroscopy",
        "category": "diagnostic",
        "description": "A thin camera (hysteroscope) is inserted through the cervix to directly visualize the uterine cavity. Can be diagnostic (looking) or operative (treating polyps, fibroids, adhesions, or septa at the same time).",
        "howItWorks": "A slender scope (3-5 mm) is passed through the cervix into the uterus. Saline or CO2 gently expands the cavity for visibility. The doctor can see the endometrium, tubal openings, and any abnormalities on a monitor. If polyps, adhesions, or a septum are found, many can be removed during the same procedure using instruments passed through the scope.",
        "duration": "10-30 minutes (diagnostic), 30-60 minutes (operative)",
        "costRange": {
          "low": 1500,
          "high": 5000
        },
        "currency": "USD",
        "anesthesia": "sedation",
        "painAndComfort": [
          "Sedation should limit discomfort during the procedure; cramping and light spotting afterward are common."
        ],
        "recoveryTime": "Same day; light activity for 1-2 days",
        "whatToExpect": [
          "Performed in an outpatient surgery center or clinic",
          "IV sedation or general anesthesia (you'll be asleep)",
          "Mild cramping and light spotting for 1-3 days afterward",
          "Most return to normal activity within 24-48 hours",
          "Results and photos reviewed at follow-up visit",
          "If operative, wait 1-2 cycles before embryo transfer"
        ],
        "results": [
          {
            "label": "Same-day findings",
            "detail": "Your doctor may know during the procedure whether the uterine cavity looked normal or whether polyps, adhesions, fibroids, or a septum were seen."
          },
          {
            "label": "Photos and report",
            "detail": "Images and the operative report are often reviewed at follow-up, especially if anything was treated."
          },
          {
            "label": "Pathology",
            "detail": "If tissue was removed, pathology may take 1-2 weeks and can affect when treatment resumes."
          }
        ],
        "prepInstructions": [
          "Schedule during the first half of your cycle (before ovulation)",
          "No food or drink after midnight if sedation is planned",
          "Arrange for a ride home",
          "Take ibuprofen 1 hour before if instructed"
        ],
        "risks": [
          "Mild cramping and spotting (common, short-lived)",
          "Very rare: uterine perforation",
          "Very rare: infection",
          "Fluid overload (extremely rare, with prolonged operative cases)"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Hystéroscopie",
          "description": "Une fine caméra (hystéroscope) est introduite à travers le col pour visualiser directement la cavité utérine. Elle peut être diagnostique (exploration) ou opératoire (résection de polypes, fibromes, adhérences ou cloison dans le même temps).",
          "howItWorks": "Un endoscope fin (3 à 5 mm) est passé par le col jusque dans l'utérus. Du sérum physiologique ou du CO2 distend délicatement la cavité pour améliorer la visibilité. Le médecin visualise l'endomètre, les ostiums tubaires et toute anomalie sur un écran. Si des polypes, adhérences ou une cloison sont détectés, beaucoup peuvent être retirés au cours de la même intervention à l'aide d'instruments passés par l'hystéroscope.",
          "duration": "10 à 30 minutes (diagnostique), 30 à 60 minutes (opératoire)",
          "recoveryTime": "Sortie le jour même ; activité légère pendant 1 à 2 jours",
          "whatToExpect": [
            "Réalisée en centre ambulatoire ou en consultation",
            "Sédation IV ou anesthésie générale (vous êtes endormie)",
            "Crampes légères et léger spotting pendant 1 à 3 jours",
            "La plupart reprennent leur activité normale en 24 à 48 heures",
            "Résultats et photos discutés lors du rendez-vous de suivi",
            "Si geste opératoire, attendre 1 à 2 cycles avant un transfert d'embryon"
          ],
          "prepInstructions": [
            "Programmez l'examen en première moitié de cycle (avant l'ovulation)",
            "À jeun à partir de minuit si une sédation est prévue",
            "Prévoyez quelqu'un pour vous raccompagner",
            "Prenez de l'ibuprofène 1 heure avant si prescrit"
          ],
          "risks": [
            "Crampes et spotting légers (fréquents, courts)",
            "Très rare : perforation utérine",
            "Très rare : infection",
            "Surcharge hydrique (extrêmement rare, lors de gestes opératoires prolongés)"
          ]
        }
      },
      "sources": [
        {
          "title": "Fertility evaluation of infertile women: a committee opinion",
          "authors": "Practice Committee of the ASRM",
          "journal": "Fertility and Sterility",
          "year": 2021,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/fertility-evaluation-of-infertile-women-a-committee-opinion-2021/",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
